import { useRouter } from 'expo-router';
import { View } from 'react-native';
import { UnistylesRuntime, useStyles } from 'react-native-unistyles';

import { useCustomerStartOtp } from '@/api/customers/use-customer-start-otp';
import ForgotPassword from '@/components/signin/forgot-password';
import { Loader } from '@/ui/loader';

export default function ProfileForgotPassword() {
  const { theme } = useStyles();
  const router = useRouter();

  const { isPending: isStartingOtp } = useCustomerStartOtp();

  if (isStartingOtp) {
    return <Loader />;
  }

  return (
    <View
      style={{
        flexGrow: 1,
        backgroundColor: theme.colors.background_2,
      }}
    >
      <View style={{ marginTop: UnistylesRuntime.insets.top }}>
        <ForgotPassword
          onBack={() => {
            router.back();
          }}
        />
      </View>
    </View>
  );
}
